export default __webpack_public_path__ + "static/media/ambulatorial-schedule.50aea588.svg";